var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBlue({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 9,
    viewBox: "0 0 10 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61016 2.24096C9.45978 1.90781 9.24294 1.6059 8.97178 1.35215C8.70043 1.09764 8.38049 0.895387 8.02937 0.756385C7.66528 0.611677 7.27477 0.537607 6.88052 0.538475C6.32741 0.538475 5.78777 0.68339 5.3188 0.95712C5.20661 1.0226 5.10003 1.09452 4.99905 1.17288C4.89808 1.09452 4.7915 1.0226 4.67931 0.95712C4.21034 0.68339 3.6707 0.538475 3.11759 0.538475C2.7193 0.538475 2.33336 0.611469 1.96874 0.756385C1.61645 0.895933 1.29895 1.09667 1.02632 1.35215C0.754813 1.60561 0.537924 1.90759 0.387948 2.24096C0.232 2.58769 0.152344 2.95588 0.152344 3.33481C0.152344 3.69227 0.228635 4.06475 0.380094 4.44368C0.506872 4.76035 0.688623 5.08882 0.920861 5.42052C1.28885 5.94543 1.79484 6.49289 2.42312 7.04786C3.46426 7.96781 4.49531 8.60329 4.53906 8.62905L4.80496 8.79222C4.92276 8.86414 5.07422 8.86414 5.19202 8.79222L5.45792 8.62905C5.50168 8.60222 6.5316 7.96781 7.57387 7.04786C8.20214 6.49289 8.70813 5.94543 9.07612 5.42052C9.30836 5.08882 9.49123 4.76035 9.61689 4.44368C9.76835 4.06475 9.84464 3.69227 9.84464 3.33481C9.84576 2.95588 9.76611 2.58769 9.61016 2.24096Z",
    fill: "#028DFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBlue);
export default __webpack_public_path__ + "static/media/heartBlue.5a3f4de169419a5103dcbed7767d3906.svg";
export { ForwardRef as ReactComponent };